export enum EIconSize {
  XL = 32,
  L = 24,
  M = 20,
  S = 16,
  XS = 10,
}
